// POPIA / GDPR data rights (121) -- request validation.
import { z } from "zod";

/** Body for POST /me/account-deletion/confirm and /cancel. */
export const confirmAccountDeletionSchema = z.object({
  token: z.string().min(1, "token is required"),
});

export type ConfirmAccountDeletionInput = z.infer<typeof confirmAccountDeletionSchema>;
